import {useTranslation} from 'next-i18next'
import AppTypography from 'src/components/elements/typography/AppTypography'

export default function BedCount(props: {sleepingTypes: any}) {
  const {sleepingTypes} = props

  const {t} = useTranslation('property')

  if (!sleepingTypes) {
    return null
  }

  const infos = []

  for (let key in sleepingTypes) {
    if (sleepingTypes[key] > 1) {
      infos.push(`${sleepingTypes[key]} ${t(key)}s`)
    } else {
      infos.push(`${sleepingTypes[key]} ${t(key)}`)
    }
  }
  const infoString = infos.join(', ')

  return (
    <AppTypography variant="body" neutralColor={500}>
      {infoString}
    </AppTypography>
  )
}
